var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提示",
        visible: _vm.dialogVisible,
        width: "500px",
        "before-close": _vm.hide,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("p", [_vm._v(_vm._s(_vm.content))]),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "flex-center" },
                  [
                    _vm._v(" 成功："),
                    _c(
                      "el-link",
                      { attrs: { type: "success", underline: false } },
                      [_vm._v(_vm._s(_vm.form.successQty))]
                    ),
                    _c("span", { staticClass: "text" }, [_vm._v("笔")]),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "flex-center" },
                  [
                    _vm._v(" 失败："),
                    _c(
                      "el-link",
                      { attrs: { type: "danger", underline: false } },
                      [_vm._v(_vm._s(_vm.form.failQty))]
                    ),
                    _c("span", { staticClass: "text" }, [_vm._v("笔")]),
                  ],
                  1
                ),
              ]),
              _vm.form.failRemark
                ? _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { span: 24 },
                    },
                    [
                      _c("p", [_vm._v("失败原因：")]),
                      _vm._l(_vm.form.failRemark, function (text, index) {
                        return _c("div", { key: index }, [_vm._v(_vm._s(text))])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("span", {
        staticClass: "dialog-footer",
        attrs: { slot: "footer" },
        slot: "footer",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }